import axiosClient from "./axiosClient";

const configurationEndpoint = "/commerce/payment-configuration";

export const commercePaymentsApi = {
  async getConfiguration() {
    const response = await axiosClient.get(configurationEndpoint, {
      __silentGenericToast: true,
    });
    return response.data;
  },
  async updateSettings(settings) {
    const response = await axiosClient.put(
      `${configurationEndpoint}/offline-methods`,
      settings,
      { __silentGenericToast: true },
    );
    return response.data;
  },
  async updateOfflineMethods(settings) {
    return this.updateSettings(settings);
  },
  async getFollowUp() {
    const response = await axiosClient.get(`${configurationEndpoint}/follow-up`, {
      __silentGenericToast: true,
    });
    return response.data;
  },
  async updateFollowUp(configuration) {
    const response = await axiosClient.put(`${configurationEndpoint}/follow-up`, configuration, {
      __silentGenericToast: true,
    });
    return response.data;
  },
  async startRazorpayAuthorization() {
    const response = await axiosClient.post(
      `${configurationEndpoint}/razorpay/authorize`,
      {},
      { __silentGenericToast: true },
    );
    return response.data;
  },
  async upsertNativeConfiguration(configuration) {
    const response = await axiosClient.put(
      `${configurationEndpoint}/native-whatsapp`,
      configuration,
      { __silentGenericToast: true },
    );
    return response.data;
  },
  async listForOrder(orderId) {
    const response = await axiosClient.get(
      `/commerce/orders/${orderId}/payments`,
      { __silentGenericToast: true },
    );
    return response.data;
  },
  async requestPayment(orderId, operationKey) {
    const response = await axiosClient.post(
      `/commerce/orders/${orderId}/payments/request`,
      { operationKey },
      { __silentGenericToast: true },
    );
    return response.data;
  },
};
